export var MembershipType;
(function (MembershipType) {
    MembershipType["Organization"] = "organization";
    MembershipType["Customer"] = "customer";
})(MembershipType || (MembershipType = {}));
export class MimboxCustomerRef {
    constructor(ref) {
        this._ref = ref;
    }
    get name() {
        return this._ref?.name;
    }
    get type() {
        return this._ref?.type || MembershipType.Customer;
    }
    get serviceAgreement() {
        return this._ref?.serviceAgreement || false;
    }
    get id() {
        return this._ref?.id;
    }
    get ancestors() {
        return this._ref?.ancestors || [];
    }
    get exists() {
        return !!this.id;
    }
}
export class Mimbox {
    constructor(data, ref) {
        this._rawData = data;
        this._customerRef = new MimboxCustomerRef(data?.customerRef);
        this.ref = ref;
    }
    isMB2() {
        return !!this._rawData.mmid && this._rawData.mimbox_vers === "MB2";
    }
    get id() {
        return this._rawData.id;
    }
    get install() {
        return this._rawData?.install;
    }
    get customer() {
        return this._customerRef;
    }
    get images() {
        return this._rawData.images || [];
    }
    get admin_page() {
        return this._rawData.admin_page;
    }
    get status() {
        return this._rawData?.status;
    }
    value(key) {
        return this._rawData[key];
    }
    get hidePerformanceData() {
        return this._rawData.hidePerformanceData;
    }
    name(staff) {
        if (staff) {
            if (this._rawData.internalName) {
                return this._rawData.internalName;
            }
        }
        if (this.install?.name) {
            return this.install.name;
        }
        if (this.install?.geodata?.street) {
            return this.install.geodata.street;
        }
        return this._rawData.serial_nr;
    }
    dump() {
        return this._rawData;
    }
    load(mimbox) {
        this._rawData = mimbox;
        return this._rawData;
    }
}
//# sourceMappingURL=types.js.map